import { useRootStore } from './useRootStore'

export function useClientDetails() {
  const {
    rootStore: { clientDetailsStore }
  } = useRootStore()

  return clientDetailsStore?.clientDetails
}
